
import commonLoginRoute from './common/route'
import ssoLoginRoute from './ssoLogin/route'

export default [
  commonLoginRoute,
  ssoLoginRoute
]
